import Cookies from 'js-cookie'
import { getApp } from './common'

class ActionPorxy {
  /**
   * 注册接口
   * @param {*} func 注册的接口方法
   * @param {array, function => array} opt.rules 校验规则，类型：数组或返回数组的函数，详见 _checkRule
   * @returns
   */
  register = (func, opt = {}) => {
    return new Proxy(func, {
      get: (_, propKey) => {
        if (propKey === 'rules') return opt.rules ?? null
        if (propKey === 'canUse') return opt.rules ? this._canUse(opt.rules) : () => true
        if (propKey === 'apply') return func
      },
      set: () => false,
    })
  }

  /**
   * Proxy - 校验 Action 是否可以使用
   * @param {string} rules
   * @param {any} data 传入的数据
   */
  _canUse = (rules) => {
    return (data) => {
      if (rules) {
        try {
          // 函数类型则执行函数获取rules配置
          if (typeof rules === 'function') {
            rules = rules(data)
          }
          // rules配置需为数组
          if (Array.isArray(rules)) {
            // 返回校验结果
            return this._checkRules(rules)
          }
        } catch (err) {
          console.error(err)
        }
        return false
      }
      // 未获取到rules则返回允许
      return true
    }
  }

  // 规则校验
  _checkRules = (rules) => {
    // 遍历规则列表，如果有一条通过，则表示通过
    return rules.map((rule) => this._checkRule(rule)).filter((e) => e).length > 0
  }

  /**
   * 规则校验-单条
   * @param {string} version 版本号，规则: xxx.xxx.xxx，如: 1.16.0
   * @param {'ios' | 'android'} app APP: ios | android
   * @returns {boolean} 是否通过
   */
  _checkRule = ({ version, app }) => {
    // 从cookie中获取app版本，无则初始为0.0.0
    const app_version = Cookies.get('insta_app_version') ?? '0.0.0'
    // 校验app
    if (app && getApp() !== app) return false
    // 校验版本
    if (version) {
      const version_arr = version.replace(/[^\d\.]/g, '').split('.')
      const app_version_arr = app_version.replace(/[^\d\.]/g, '').split('.')
      let index = 0
      while (version_arr[index] !== undefined) {
        const version_item = parseInt(version_arr[index]) || 0
        const app_version_item = parseInt(app_version_arr[index]) || 0
        if (version_item > app_version_item) return false
        index++
      }
    }
    return true
  }
}

export default new ActionPorxy()
